module.exports = __webpack_public_path__ + "static/media/clienteagro8.0f5dab29.webp";